
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form14";
const form14State = namespace("Form14");

import Form14ProcessHeader from "@/components/process/Form14/components/Form14ProcessHeader.vue";
import Form14 from "@/components/process/Form14/components/pdf/Form14.vue"

import { form14StatusInfoType } from '@/types/Information/Form14';

@Component({
    components:{
        Form14ProcessHeader,
        Form14
    }
})
export default class PreviewForm14 extends Vue {

    @form14State.State
    public currentConsentOrderRemoveInactiveId: string;

    stepsCompleted = {} as form14StatusInfoType;
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form14" }); 
    }
}
